import styled from 'styled-components';

export const StyledInfoIcon = styled.span`
  color: ${(props) => props.theme.atlas.semantic.color.action.primary.default};
`;
